// src/components/ProgressBar.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const ProgressBarContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    scrollbarWidth: 'none',
}));

const ProgressStepContainer = styled(Box)(({ theme, active, completed }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '0 0 auto',
    padding: theme.spacing(0, 1),
    '& .MuiSvgIcon-root': {
        color: completed ? theme.palette.primary.main : (active ? theme.palette.primary.main : theme.palette.grey[300]),
        fontSize: '1.2rem',
    },
    '& .MuiTypography-root': {
        color: active ? theme.palette.text.primary : theme.palette.text.secondary,
        fontSize: '0.65rem',
        marginTop: theme.spacing(0.5),
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
}));

const ProgressLineStyled = styled(Box)(({ theme, completed }) => ({
    height: 1,
    width: '100%',
    backgroundColor: completed ? theme.palette.primary.main : theme.palette.grey[300],
    flex: '1 1 auto',
}));

const ProgressBar = ({ steps }) => {
    return (
        <ProgressBarContainer>
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                    <ProgressStepContainer active={step.active} completed={step.completed}>
                        {step.completed ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                        <Typography>{step.label}</Typography>
                    </ProgressStepContainer>
                    {index < steps.length - 1 && (
                        <ProgressLineStyled completed={steps[index + 1]?.completed} />
                    )}
                </React.Fragment>
            ))}
        </ProgressBarContainer>
    );
};

export default ProgressBar;
